import { Locale } from '@/models/system';

export const isDevelopment =
    process.env.BUILD_MODE === 'development' ||
    process.env.BUILD_MODE === 'staging';

export const isB2B =
    typeof window !== 'undefined' && window.location.host.includes('b2b');

if (isDevelopment) {
    console.warn(process.env.BUILD_MODE);
}

export const APP_VERSION = '0.0.1';

export const API = isDevelopment
    ? 'https://api.staging.starjack.at/'
    : 'https://api.starjack.at/';

export const DEFAULT_API_VERSION = 'v1/';
export const LOCAL_STORAGE_KEY = 'starjackAdmin';

// localstorage nodes
export const LOCAL_STORAGE_KEY_AUTH = 'auth';

export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';

export const DATE_FORMAT_DISPLAY = 'DD.MM.JJJJ';

export const DATE_FORMAT_BACKEND_STRING = 'yyyy-MM-dd';

export const WEEKDAYS = {
    MONDAY: 'Montag',
    TUESDAY: 'Dienstag',
    WEDNESDAY: 'Mittwoch',
    THURSDAY: 'Donnerstag',
    FRIDAY: 'Freitag',
    SATURDAY: 'Samstag',
    SUNDAY: 'Sonntag',
};

export const ACCEPTED_FILES_IMAGE = {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
};

export const locale = Locale.DE;
